import { CheckOutlined } from '@ant-design/icons';
import { StyledCheckbox } from './Checkbox.styled';

type CheckboxProps = {
  checked: boolean;
  disabled: boolean;
  className?: string;
  ariaHidden?: boolean;
};

export default function Checkbox(props: CheckboxProps) {
  const { ariaHidden, ...checkboxProps } = props;

  return (
    <StyledCheckbox
      role={ariaHidden ? undefined : 'checkbox'}
      aria-hidden={ariaHidden || undefined}
      {...checkboxProps}
    >
      {props.checked ? <CheckOutlined /> : null}
    </StyledCheckbox>
  );
}
